/**
 * The Error Handler is a central hub that is used to handle all the errors
 * of the software.
 *
 */

type ErrorHandlerFunction =
  | ((error: Error | ErrorEvent) => boolean | undefined)
  | ((error: Error | ErrorEvent) => boolean)
  | ((error: Error | ErrorEvent) => void);

export class ErrorHandler {
  handlers: ErrorHandlerFunction[];

  constructor() {
    this.handlers = [];
  }

  /**
   * Calls all error handlers on the error.
   * Stops the error if it was handled, throw the error again if not.
   * @param error
   */
  handle(error: (Error | ErrorEvent) & { status?: number }) {
    // we're stepping backwards through the handlers
    // to make sure that the LAST added will be used first
    let i = this.handlers.length;
    while (i--) {
      const handler = this.handlers[i];
      const handled = handler(error);
      if (handled) {
        console.log(`handled ${error.status} ${error.message}`);
        return true;
      }
    }
    //this.onUnhandled(error);
  }

  /**
   * Defines what happens with unhandled errors.
   */
  onUnhandled(error: Error | ErrorEvent) {
    throw error;
  }

  add(handler: ErrorHandlerFunction) {
    this.handlers.push(handler);
  }

  remove(handler: ErrorHandlerFunction) {
    const index = this.handlers.indexOf(handler);
    this.handlers.splice(index, 1);
  }

  register(window: Window) {
    window.addEventListener("error", (error) => {
      if (this.handle(error)) {
        return true;
      }
      return false;
    });
    window.addEventListener("unhandledrejection", (event) => {
      if (this.handle(event.reason)) {
        event.preventDefault();
      }
    });
  }
}

export const globalErrorHandler = new ErrorHandler();
export default globalErrorHandler;
